import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { redirectIfAuthenticatedGuard } from '@lfg-guards/auth-redirect/auth-redirect.guard';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./private/dashboard/dashboard.module').then(m => m.DashboardModule),
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewsRoutingModule { }
